import { Flex } from 'ui'

import { useSpendMetrics } from 'queries/pulse/useSpendMetrics'
import { usePulseContext } from '../../context/PulseProvider'
import { MetricBox } from '../MetricBox'
import { formatCurrency } from 'lib/string'

export function SpendMetrics() {
  const {
    state: { filters },
  } = usePulseContext()

  const { data, isLoading } = useSpendMetrics(filters)

  return (
    <Flex
      flexWrap={'wrap'}
      flexDirection={['column', 'row', 'row']}
      justifyContent="space-between"
      gap={2}
    >
      <MetricBox
        title="Total Spend"
        value={formatCurrency(data?.total_spend ?? 0)}
        isLoading={isLoading}
      />
      <MetricBox
        title="Total Spend in Base Wages"
        value={formatCurrency(data?.wages_spend ?? 0)}
        isLoading={isLoading}
      />
      <MetricBox
        title="Total Spend in Bonus"
        value={formatCurrency(data?.bonus_spend ?? 0)}
        isLoading={isLoading}
      />
      <MetricBox
        title="Other Spend or Discounts"
        value={formatCurrency(data?.other_spend_or_discount ?? 0)}
        isLoading={isLoading}
      />
    </Flex>
  )
}
